import uniqueId from 'lodash/uniqueId';

export default {
   name: 'Checkbox',
   props: {
      val: {
         type: Boolean,
         default: false
      },
      label: {
         type: String,
         default: ''
      },
      float: { // checkbox position
         type: String, // left|right
         default: 'left'
      },
      showOnly: {
         type: Boolean,
         default: false
      },
      disabled: {
         type: Boolean,
         default: false
      },
      theme: {
         type: String,
         default: 'light' // dark|light
      }
   },
   data() {
      return {
         model: !!this.val,
         id: uniqueId('checkbox')
      };
   },
   computed: {
      showOnlyLink() {
         return this.showOnly;
      }
   },
   methods: {
      toggle() {
         if (this.disabled) {
            return;
         }
         this.model = !this.model;
         this.onchange();
      },
      onchange() {
         this.$nextTick(() => this.$emit('change', this.model));
      },
      only() {
         this.$nextTick(() => this.$emit('only', true));
      }
   },
   watch: {
      val(val) {
         this.model = val;
      }
   }
};
